/* eslint-disable */
import { MutationTree, ActionTree, GetterTree, ActionContext } from 'vuex';
import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';
import IMarketingBoxStoreState from '@/interfaces/IMarketingBoxStoreState';

export const state: IMarketingBoxStoreState = {
  id: null,
  data: {
    titleImg: null,
    titleText: null,
    text: null,
    imgDesktop: {
      url: null,
      alt: null
    },
    imgMobile: {
      url: null,
      alt: null
    }
  },
  showMarketingBox: false,
  showTrustpilotForMobile: true
};

export const actions: ActionTree<IMarketingBoxStoreState, any> = {
  async getData(
    { commit, state }: ActionContext<IMarketingBoxStoreState, any>,
    step: number
  ): Promise<void> {
    if (state.id) {
      await axios
        .get(
          Utility.constants().API.marketingBox_get + step.toString() + '?policyCacheId=' + state.id
        )
        .then((response) => {
          if (response.status === 200 && response.data) {
            commit('setData', response.data);
            commit('setShowTrustpilotForMobile', response.data.ShowTrustpilotScore ?? false);
            if (
              response.data.TitleImage === '' ||
              response.data.TitleImage === null ||
              response.data.TitleText === '' ||
              response.data.TitleText === null ||
              response.data.Text === '' ||
              response.data.Text === null ||
              !response.data.ImageDesktop ||
              !response.data.ImageDesktop.Url ||
              response.data.ImageDesktop.Url === '' ||
              response.data.ImageDesktop.Url === null ||
              !response.data.ImageMobile ||
              !response.data.ImageMobile.Url ||
              response.data.ImageMobile.Url === '' ||
              response.data.ImageMobile.Url === null
            ) {
              commit('setShowMarketingBox', false);
            } else {
              commit('setShowMarketingBox', true);
            }
          }
          if (response.status === 204) {
            commit('setShowMarketingBox', false);
          }
        })
        .catch(() => {
          commit('setShowMarketingBox', false);
        });
    }
  },
  setId({ commit }, id) {
    commit('setId', id);
  }
};

export const mutations: MutationTree<IMarketingBoxStoreState> = {
  setId(state, payload) {
    state.id = payload;
  },
  setData(state, payload) {
    if (state.data) {
      state.data.titleImg = payload.TitleImage ?? '';
      state.data.titleText = payload.TitleText ?? '';
      state.data.text = payload.Text ?? '';
      state.data.imgDesktop = {
        url: (payload.ImageDesktop && payload.ImageDesktop.Url) ?? '',
        alt: (payload.ImageDesktop && payload.ImageDesktop.Alt) ?? ''
      };
      state.data.imgMobile = {
        url: (payload.ImageMobile && payload.ImageMobile.Url) ?? '',
        alt: (payload.ImageMobile && payload.ImageMobile.Alt) ?? ''
      };
    }
  },
  setShowMarketingBox(state, payload) {
    state.showMarketingBox = payload;
  },
  setShowTrustpilotForMobile(state, payload) {
    state.showTrustpilotForMobile = payload;
  }
};

export const getters: GetterTree<IMarketingBoxStoreState, any> = {
  getId(state) {
    return state.id;
  },
  getShowTrustpilotForMobile(state) {
    return state.showTrustpilotForMobile;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
